import { down } from 'styled-breakpoints'
import styled, { css } from 'styled-components'
import ripple from '../../../styles/animations/ripple'
import { darken } from 'polished'

export const Container = styled.div<{
  onClick: any
  disabled: boolean
  active: boolean
}>`
  ${ripple};

  background-color: transparent;
  -webkit-appearance: none;
  align-items: center;
  display: flex;

  transition: background-color 200ms linear, box-shadow 200ms linear, border-color 200ms linear;
  border: 0;
  gap: 10px;
  width: 100%;
  cursor: pointer;
  padding: 5px;

  ${({ active }) =>
    active &&
    css`
      background-color: ${({ theme }) => darken(-0.5, theme.colors.primary)};
      border-radius: 4px;
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      pointer-events: none;

      opacity: 60%;
    `}
`

export const Label = styled.div`
  text-align: left;
  font-size: 14px;
  display: inline-block;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 700;
  font-style: normal;
  text-transform: uppercase;
  ${down('md')} {
    font-size: 18px;
  }
`
